import { indexedDbStorage } from '@/lib/storage/indexedDbStorage'
import { ExecutionContext, WorkflowExecutionResponse } from 'sprites-types/api/v2/workflows'

export class ExecutionService {
  private static instance: ExecutionService

  private constructor() {}

  static getInstance(): ExecutionService {
    if (!ExecutionService.instance) {
      ExecutionService.instance = new ExecutionService()
    }
    return ExecutionService.instance
  }

  async getExecutionData(executionId: string): Promise<WorkflowExecutionResponse> {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BACKEND_API_ENDPOINT_URI}/v2/workflows/execution/${executionId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      }
    )

    if (!response.ok) {
      throw new Error(`Failed to fetch execution data: ${response.status}`)
    }

    return (await response.json()) as WorkflowExecutionResponse
  }

  async loadExecutionDataIntoSession(sessionId: string, executionId: string): Promise<void> {
    try {
      // Get execution data
      const executionData = await this.getExecutionData(executionId)

      // Store execution data in IndexedDB for the copilot to pick up
      await indexedDbStorage.saveExecutionContext(
        sessionId,
        executionId,
        executionData.executionData,
        executionData.nodeExecutions
      )

      console.log('Execution data loaded into IndexedDB', {
        sessionId,
        executionId,
      })
    } catch (error) {
      console.error('Failed to load execution data into session:', error)
      throw error
    }
  }

  async getExecutionContext(sessionId: string): Promise<ExecutionContext | null> {
    try {
      const storedContext = await indexedDbStorage.loadExecutionContext(sessionId)
      if (!storedContext) return null

      return {
        executionId: storedContext.executionId,
        executionData: storedContext.executionData as ExecutionContext['executionData'],
        nodeExecutions: storedContext.nodeExecutions,
      }
    } catch (error) {
      console.error('Failed to get execution context:', error)
      return null
    }
  }

  async clearExecutionContext(sessionId: string): Promise<void> {
    await indexedDbStorage.deleteExecutionContext(sessionId)
  }
}

export const executionService = ExecutionService.getInstance()
